<template>
  <div class="userCode-page">
    <div class="userCode-main">
      <div class="userCode-container">
        <div class="codeTitle">
          {{ passTypeSet == 0 ? "账号密码已过期,设置新密码" : "重置密码" }}
        </div>

        <el-form
          :model="codeForm"
          ref="codeForm"
          label-width="100px"
          :rules="rules"
        >
          <el-form-item label="账号" class="virtual">
            {{ accountNumber }}
          </el-form-item>
          <el-form-item label="规则" class="virtual">
            密码由
            <span class="height">
              {{ rules.newCode[1].max }}位字符{{
                codeType ? "【" + codeTypeArray[codeType - 1].label + "】" : ""
              }}
            </span>
            组成
          </el-form-item>

          <el-form-item label="原密码" prop="oldCode" v-if="passTypeSet == 0">
            <el-input
              :type="inputType[0]"
              v-model="codeForm.oldCode"
              placeholder="请输入原密码"
            >
              <i slot="suffix" :class="icon[0]" @click="showPass(0)"></i>
            </el-input>
          </el-form-item>
          <el-form-item label="新密码" prop="newCode">
            <el-input
              :type="inputType[1]"
              v-model="codeForm.newCode"
              placeholder="请输入新密码"
            >
              <i slot="suffix" :class="icon[1]" @click="showPass(1)"></i>
            </el-input>
          </el-form-item>
          <el-form-item label="确认新密码" prop="newCodeAgain">
            <el-input
              :type="inputType[2]"
              v-model="codeForm.newCodeAgain"
              placeholder="请再次确认新密码"
            >
              <i slot="suffix" :class="icon[2]" @click="showPass(2)"></i>
            </el-input>
          </el-form-item>
        </el-form>
        <div class="footer">
          <el-button
            :loading="formLoading"
            @click="handleCancelForm"
          >
            取消
          </el-button>
          <el-button
            type="primary"
            :loading="formLoading"
            @click="handleSubmitForm"
          >
            确定
          </el-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import sha256 from "js-sha256";
export default {
  data() {
    return {
      passTypeSet: "0", //0-密码过期，1重置密码
      codeTypeArray: [
        {
          label: "任意字符",
          value: 1,
        },
        {
          label: "字母+数字混和",
          value: 2,
        },
        {
          label: "大写字母+小写字母+数字混合",
          value: 3,
        },
      ],
      codeType: 1,
      rules: {
        oldCode: [{ required: true, message: "请输入原密码", trigger: "blur" }],
        newCode: [
          {
            required: true,
            message: "请输入新密码",
            trigger: ["blur"],
          },
          {
            min: 6,
            max: 6,
            message: "密码长度为6个字符",
            trigger: ["blur", "change"],
          },
          { validator: this.validatePwd, trigger: ["blur", "change"] },
        ],
        newCodeAgain: [
          { required: true, message: "请再次输入新密码" },
          { validator: this.validatePass, trigger: ["blur", "change"] },
        ],
      },
      formLoading: false,
      accountNumber: "",
      codeForm: {
        oldCode: "",
        newCode: "",
        newCodeAgain: "",
      },
      //用于改变Input类型
      inputType: ["password", "password", "password"],
      icon: [
        "el-input__icon el-icon-view",
        "el-input__icon el-icon-view",
        "el-input__icon el-icon-view",
      ],
      verificationCode: "",
    };
  },
  created() {
    this.accountNumber = this.$route.query.accountNumber;
    this.passTypeSet =
      (this.$route.query && this.$route.query.passTypeSet) || "0";
    this.verificationCode =
      (this.$route.query && this.$route.query.verificationCode) || "";
    this.getSyConfig();
  },
  methods: {
    getSyConfig() {
      let params = {
        cfgCode: "PASSWORD_FORMAT,PASSWORD_LENGTH",
        pageNum: 1,
        pageSize: 10,
      };
      this.$fetch(this.$api.common.querySysConfig, params).then((res) => {
        if (res.success) {
          this.codeType = Number(res.returnObj.list[0].cfgValue); //3
          this.rules.newCode[1].max = Number(res.returnObj.list[1].cfgValue);
          this.rules.newCode[1].min = Number(res.returnObj.list[1].cfgValue);
          this.rules.newCode[1].message =
            "密码长度为" + this.rules.newCode[1].max + "位字符";
        }
      });
    },
    validatePwd(rule, value, callback) {
      let reg = "";
      if (this.codeType == 2) {
        // 数字+任意英文
        reg = new RegExp("^((?=.*\\d)(?=.*[A-Za-z]))[0-9a-zA-Z]*$");
      } else if (this.codeType == 3) {
        //数字+英文(大写+小写)
        reg = new RegExp("^((?=.*\\d)(?=.*[a-z])(?=.*[A-Z]))[0-9a-zA-Z]*$");
        // ^((?=.*\\d)(?=.*[a-z])(?=.*[A-Z]))[0-9a-zA-Z]*$
      } else {
        //任意密码
        callback();
        return;
      }
      if (!reg.test(value)) {
        callback(
          new Error(
            "密码格式错误,必须包含" +
              this.codeTypeArray[this.codeType - 1].label
          )
        );
      } else {
        callback();
      }
    },
    validatePass(rule, value, callback) {
      if (value === "") {
        callback(new Error(this.$t("base.message.againPwd")));
      } else if (value !== this.codeForm.newCode) {
        callback(new Error(this.$t("base.message.diffPwd")));
      } else {
        callback();
      }
    },
    showPass(type) {
      if (this.inputType[type] == "text") {
        this.$set(this.inputType, type, "password");
        this.$set(this.icon, type, "el-input__icon el-icon-view");
      } else {
        this.$set(this.inputType, type, "text");
        this.$set(this.icon, type, "el-input__icon el-icon-loading");
      }
    },
    handleCancelForm() {
      this.$router.push({
        path: "/Login",
      });
    },
    handleSubmitForm() {
      this.$refs["codeForm"].validate((valid) => {
        if (valid) {
          const self = this;
          let params = {};
          let url = this.$api.common.updatePass;
          if (self.passTypeSet == 1) {
            url = this.$api.common.resetPassword;
            params = {
              accountNumber: self.accountNumber,
              verificationCode: self.verificationCode,
              password: sha256(self.codeForm.newCode),
              confirmPassword: sha256(self.codeForm.newCodeAgain),
            };
          } else {
            params = {
              accountNumber: self.accountNumber,
              oldPassword: sha256(self.codeForm.oldCode),
              newPassword: sha256(self.codeForm.newCode),
              confirmPassword: sha256(self.codeForm.newCodeAgain),
            };
          }

          if (params.accountNumber === this.codeForm.newCode) {
            self.$message.error(this.$t("base.message.sameWithAccount"));
          } else {
            self.$fetch(url, params).then((res) => {
              if (!res.success) {
                self.$message.error(res.msgContent);
              } else {
                self.$message.success(this.$t("base.message.editPwdSuccess"));
                setTimeout(() => {
                  this.handleCancelForm();
                }, 100);
              }
            });
          }
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~@src/common/assets/style/mixin";
.el-input__icon {
  cursor: pointer;
}
:deep .el-input__inner {
  height: 40px;
  line-height: 40px;
}
.userCode-page {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  .userCode-main {
    width: 700px;
    height: 400px;
    border-radius: 5px;
    padding: 10px 16px;
    @include set_theme_color(background-color, blur-color);
  }
  .userCode-container {
    .codeTitle {
      text-align: center;
      margin: 25px 0;
      font-size: 24px;
    }
    .virtual {
      color: #9aa6c1;
    }
    .height {
      color: #3e76e6;
    }
  }
  .footer {
    margin-top: 10px;
    text-align: center;
  }
}
</style>